export const isDrupalSessionActive = () =>
  document.cookie.includes('DRUPAL_AUTHENTICATED_USER=') &&
  !document.cookie.includes('DRUPAL_AUTHENTICATED_USER=front-user');
